// src/constants/eixos.js

export const EIXOS = [
  { value: 'Liderança', label: 'Liderança' },
  { value: 'Estratégia', label: 'Estratégia' },
  { value: 'Controle', label: 'Controle' },
  { value: 'Gestão de Pessoas', label: 'Gestão de Pessoas' },
  { value: 'Gestão da Tecnologia da Informação e da Segurança da Informação', label: 'Gestão da Tecnologia da Informação e da Segurança da Informação' },
  { value: 'Gestão de Contratações', label: 'Gestão de Contratações' },
  { value: 'Gestão Orçamentária', label: 'Gestão Orçamentária' },
  { value: 'Sustentabilidade ambiental', label: 'Sustentabilidade ambiental' },
  { value: 'Sustentabilidade social', label: 'Sustentabilidade social' },
];

